import { render, staticRenderFns } from "./EventContestDetail.vue?vue&type=template&id=4cd443a2&scoped=true"
import script from "./EventContestDetail.vue?vue&type=script&lang=ts"
export * from "./EventContestDetail.vue?vue&type=script&lang=ts"
import style0 from "./EventContestDetail.vue?vue&type=style&index=0&id=4cd443a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd443a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd443a2')) {
      api.createRecord('4cd443a2', component.options)
    } else {
      api.reload('4cd443a2', component.options)
    }
    module.hot.accept("./EventContestDetail.vue?vue&type=template&id=4cd443a2&scoped=true", function () {
      api.rerender('4cd443a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventContestDetail.vue"
export default component.exports